import MetaQueryFieldList from './MetaQueryFieldList';
import Noun from '../core/Noun';
import MetaQueryField from './MetaQueryField';

class MetaQuery extends Noun {
  constructor(args = {}) {
    const {
      data = {},
    } = args;

    const {
      template,
      ...restData
    } = data;

    super({ ...args, data: restData });

    this.fieldList = new MetaQueryFieldList({ data: template, parent: this });
  }

  export() {
    const _attributeMap = super.export();

    return {
      ..._attributeMap,
      template: this.fieldList.list().map(v => v.export()),
    };
  }

  id() {
    return this.attr('rel');
  }

  merge(other) {
     if (!this.shouldMerge(other)) {
      return;
    }

    super.merge(other);

    this.fieldList.merge(other.fieldList);

    return this;
  }

  template() {
    return this.fieldList;
  }

  field(key) {
    if (key === undefined) {
      throw new Error('Usage: Key is required.');
    }

    const field = this.fieldList.item(key);

    if (!field) {
      return null;
    }

    return this.fieldList.item(key);
  }
}

export default MetaQuery;
